import { IconProps } from "@utils/types/components";

export const HelpIcon = ({
  width,
  height,
  color = "currentcolor",
  ...props
}: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.991 15.35c.32 0 .59-.11.81-.331.221-.22.331-.49.331-.81 0-.319-.11-.589-.33-.809-.221-.22-.491-.331-.81-.331-.32 0-.59.11-.81.331a1.1 1.1 0 00-.331.81c0 .319.11.588.33.809.221.22.491.331.81.331zm-.82-3.513h1.687c0-.502.057-.897.172-1.186.114-.29.437-.685.969-1.187.395-.395.707-.772.935-1.13.228-.356.343-.786.343-1.288 0-.851-.312-1.505-.936-1.962-.623-.456-1.361-.684-2.213-.684-.867 0-1.57.228-2.11.684A3.62 3.62 0 006.89 6.727l1.506.593c.076-.274.247-.57.513-.89.266-.32.673-.479 1.22-.479.487 0 .852.133 1.095.399.244.266.365.56.365.879 0 .304-.09.589-.273.855-.183.266-.411.514-.685.742-.669.593-1.08 1.041-1.232 1.346-.152.304-.228.859-.228 1.665zM10.036 19a8.882 8.882 0 01-3.559-.719 9.209 9.209 0 01-2.897-1.95 9.208 9.208 0 01-1.95-2.897 8.881 8.881 0 01-.719-3.559c0-1.262.24-2.449.72-3.559a9.209 9.209 0 011.95-2.897 9.221 9.221 0 012.896-1.95 8.89 8.89 0 013.56-.719 8.89 8.89 0 013.558.718 9.22 9.22 0 012.897 1.951 9.209 9.209 0 011.95 2.897c.48 1.11.72 2.297.72 3.559s-.24 2.448-.72 3.559a9.208 9.208 0 01-1.95 2.897 9.208 9.208 0 01-2.897 1.95 8.882 8.882 0 01-3.559.719z"
        fill={color}
      />
    </svg>
  );
};
